import {LocationProvider, ErrorBoundary, Router, Route} from 'preact-iso';

import HomePage from './pages/HomePage.jsx';
import ProductsPage from './pages/ProductsPage.jsx';
import ProductPage from './pages/ProductPage.jsx';
import AddonGroupPage from './pages/AddonGroupPage.jsx';
import ProductLinkPage from './pages/ProductLinkPage.jsx';
import NotFoundPage from './pages/NotFoundPage.jsx';
import CollectionsPage from './pages/CollectionsPage.jsx';
import CollectionLinkPage from './pages/CollectionLinkPage.jsx';
import CollectionSortPage from './pages/CollectionSortPage.jsx';

export default function App() {
  return (
    <LocationProvider>
      {!__STANDALONE__ && <s-app-nav>
        <s-link href="/products">Products</s-link>
        <s-link href="/collections">Collections</s-link>
      </s-app-nav>}
      <ErrorBoundary onError={(error) => {
        console.error('[app-home] render error', error);
        try { shopify.toast.show(`RENDER ERROR: ${(error && (error.message || error.toString())) || 'unknown'}`); } catch (_) { /* no-op */ }
      }}>
        <Router>
          <Route path="/" component={HomePage} />
          <Route path="/products" component={ProductsPage} />
          <Route path="/product-link" component={ProductLinkPage} />
          <Route path="/products/:id/add-ons/:groupId" component={AddonGroupPage} />
          <Route path="/products/:id" component={ProductPage} />
          <Route path="/collections" component={CollectionsPage} />
          <Route path="/collection-link" component={CollectionLinkPage} />
          <Route path="/collections/:id/sorting" component={CollectionSortPage} />
          <Route default component={NotFoundPage} />
        </Router>
      </ErrorBoundary>
    </LocationProvider>
  );
}
